import { services } from '@broadleaf/admin-components';

import PDFAssetDropzoneField from "./PDFAssetDropzoneField";

const { ComponentRegistrar } = services;

ComponentRegistrar.registerFieldComponent('ASSET_DROPZONE', PDFAssetDropzoneField);
